<template>
  <el-aside width="200px" style="background-color: #000;">
    <el-menu :default-openeds="[]" :default-active="menuIndex" @select="onSelect">
      <el-menu-item index="message-list">聯絡訊息</el-menu-item>
      <el-menu-item index="post-list">文章列表</el-menu-item>
      <el-menu-item index="post-tag-list">文章#hashtag</el-menu-item>
      <el-menu-item index="work-list">作品集列表</el-menu-item>
      <el-menu-item index="content-template-list">內容範本</el-menu-item>
    </el-menu>
  </el-aside>
</template>

<style>
.el-aside {
  color: #333;
}
</style>

<script>
export default {
  data () {
    return {
      menuIndex: ''
    }
  },
  methods: {
    onSelect (index) {
      this.menuIndex = index
      this.$router.push({ name: index })
    }
  },
  created () {
    this.menuIndex = this.$route.name || 'message-list'
  }
}
</script>

<style>
.el-aside .el-menu-item {
  background-color: #000;
  color: #fff;
}
.el-aside .el-menu-item.is-active {
  color: #fff;
  border-bottom: 1px solid #fff;
  font-weight: bold;
}
.el-aside .el-menu-item:focus,
.el-aside .el-menu-item:hover {
  background-color: #333;
}
</style>
